<template>
    <div>
        <!-- <v-card class="mb-4 mt-0" elevation="0"> -->
            <!-- <v-card-text> -->
                
                <!-- <v-row>
                    <v-col>
                        <vue-editor 
                        ref="myEditor"
                        v-model="content" 
                        use-custom-editor 
                        @text-change="handleTextChange"
                        @image-added="handleImageAdded"
                        useCustomImageHandler
                        :editor-options="editorSettings"
                        :editor-toolbar="customToolbar"
                        />
                    </v-col>
                </v-row> -->

                <v-row>
                    <v-col>
                        <el-tiptap
                        ref="miEditor"
                        :content="contentForEditor"
                        :extensions="extensions"
                        output="json"
                        lang="es"
                        @onUpdate="onEditorUpdate"
                        :tooltip="true"
                        />
                    </v-col>
                </v-row>
                <button @click="showJson">Ver JSON en Consola</button>

                <v-row>
                    <v-col>
                        <textFieldForm 
                            @valueChange="(v) => {valStringJson = v.trim()}" 
                            :valueInput="valStringJson" 
                            label="Json"
                            :clearable="true"
                        ></textFieldForm>
                    </v-col>
                </v-row>
                 <button @click="setEditorContent">Cargar JSON</button>
               
                
            <!-- </v-card-text> -->
        <!-- </v-card> -->

    </div>
</template>

<script>
// import { VueEditor } from "vue2-editor";

import {
    Doc, Paragraph, Text,
    Heading,
    Bold,
    Italic,
    Underline,
    Strike,
    Code,
    CodeBlock,
    Blockquote,
    Link,
    Image,
    BulletList, OrderedList, ListItem,
    TodoList, TodoItem,
    Table, TableHeader, TableRow, TableCell,
    TextAlign,
    LineHeight,
    Indent,
    HorizontalRule,
    History,
    TextColor, TextHighlight,
    FormatClear,
    FontType, FontSize,
    Print, SelectAll,
} from 'element-tiptap';
/* eslint-disable */
export default {
    props: ['values', 'serverErrors'],
    components: {
    
    },
    data(){
        return {
            valStringJson: '{"type":"doc","content":[{"type":"paragraph","attrs":{"textAlign":null,"indent":null,"lineHeight":null},"content":[{"type":"text","text":"sss"}]}]}',
            content: null,
            editorContentJson: null,
            contentForEditor: '',
            modeeel: null,
            // customToolbar: [
            //     ["bold", "italic", "underline"],
            //     [{ list: "ordered" }, { list: "bullet" }],
            //     ["table"], // <--- Esto añade el botón de tabla
            //     ["clean"]
            // ],
            // editorSettings: {
            //     modules: {
            //     table: true
            // }
            extensions: [
                new Doc(),
                new Text(),
                new Paragraph(),
                new Heading({ level: 5 }),
                new Bold({ bubble: true }), // render command-button in bubble menu.
                new Underline({ bubble: true, menubar: false }), // render command-button in bubble menu but not in menubar.
                new Italic(),
                new Strike(),
                new ListItem(),
                new BulletList(),
                new OrderedList(),
                new Code(),
                new CodeBlock(),
                new Blockquote(),
                new Link(),
                new TodoList(),
                new TodoItem(),
                new Table({ bubble: true }),
                new TableHeader(),
                new TableRow({ bubble: true }),
                new TableCell({ bubble: true }),
                new TextAlign(),
                new LineHeight(),
                new Indent(),
                new HorizontalRule(),
                new History(),
                new TextColor(),
                new TextHighlight(),
                new FormatClear(),
                new FontType(),
                new FontSize(),
                new Print(),
                new SelectAll(),
                new Image({
                    // Esta función se ejecuta automáticamente cuando el usuario selecciona un archivo
                    uploadRequest: async (file) => {
                        
                        // 1. Preparar el FormData para enviar el archivo a tu API
                         var formData = new FormData();
                        formData.append("file", file);
                        formData.append("name", 'test');

                        const result = await this.$api.course.uploadImageBodyLesson(formData);
                        console.log(result)
                        return result.data.data.url
                    }
                    
                }),
            ],

          
        }
    },
    watch: {
        values: function (vv) {
            //console.log(this.values, vv);
        }
    },
    mounted(){
        
    },
    methods: {
        handleTextChange() {
        // Obtenemos el objeto Delta nativo de Quill
        const delta = this.$refs.myEditor.quill.getContents();
        
        // Lo asignamos a nuestra variable de estado
        this.editorContentJson = delta;
        },
        
        showJson() {
            // 4. Muestra la estructura JSON limpia en tu consola
            console.log((this.modeeel));
        },
        setEditorContent: function() {
            // 1. Convertimos el string de la base de datos a un Objeto JS real
            const jsonObjeto = JSON.parse(this.valStringJson);
            
            // 2. Usamos la referencia para inyectar el JSON con formato
            // Ponemos un elvis operator (?.) o un if por si el editor aún no se ha renderizado
            if (this.$refs.miEditor) {
                this.$refs.miEditor.editor.setContent(jsonObjeto);
            }
        },

        handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
        // handleImageAdded: function(file,) {
            console.log("entra habdle", file)
            // An example of using FormData
            // NOTE: Your key could be different such as:
            // formData.append('file', file)

            var formData = new FormData();
            formData.append("file", file);
            formData.append("name", 'test');

            // axios({
            //     url: "https://fakeapi.yoursite.com/images",
            //     method: "POST",
            //     data: formData
            // })
            //     .then(result => {
            //     const url = result.data.url; // Get url from response
            //     Editor.insertEmbed(cursorLocation, "image", url);
            //     resetUploader();
            //     })
            //     .catch(err => {
            //     console.log(err);
            //     });

            this.$api.course.uploadImageBodyLesson(formData)
                .then((result) => {
                    console.log(result);
                    const url = result.data.data.url; // Get url from response
                    Editor.insertEmbed(cursorLocation, "image", url);
                    resetUploader();
                })
                .catch((error) => {
                    //console.log(error.response)
                    var errors = []
                    switch(error.response.status){
                        case 400: 
                            //console.log(99, error.response);
                            if(("message" in error.response.data)){
                                Object.keys(error.response.data.message).forEach((x) => {
                                    //console.log(x);
                                    this.serverErrors = error.response.data.message;
                                    error.response.data.message[x].forEach((y) => {
                                        this.serverErrors[x] = Utils.deleteWord(x,y);
                                        errors.push(Utils.deleteWord(x,y))
                                    })
                                });
                                this.$store.dispatch('snackbarError', errors.join('.<br>'));
                            }
                            
                        break;
                        
                    }

                    
                })
                .finally(() => {
                    this.saveBtnData.loading = false;
                    this.$store.state.loading = false;
                })
            ;
        },

        onEditorUpdate(outputFromEditor) {
            // Cuando el usuario escribe, aquí recibes el OBJETO JSON puro
            // Puedes guardarlo directamente en tu variable de control
            this.modeeel = outputFromEditor;
        }
       
        
    }
}
</script>

<style>
.ql-editor table {
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 10px;
}

.ql-editor td, .ql-editor th {
  border: 1px solid #ccc;
  padding: 8px;
  min-width: 40px;
}
</style>